import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router'

import { APPLICANT_PROFILE_BLOCK_PARAM } from '../../../../../../RentalPortalApplicant'
import { APPLICANT_DECISION_ANCHOR_SCROLL_OPTIONS } from '../../ApplicantDecisionPanel.constants'

import { getIsApplicantDecisionAnchorRequested } from './useApplicantDecisionAnchor.utils'

export function useApplicantDecisionAnchor(isPanelReady) {
  const anchorRef = useRef(null)

  const [searchParams, setSearchParams] = useSearchParams()

  const isRequested = getIsApplicantDecisionAnchorRequested(searchParams)

  useEffect(() => {
    if (isRequested && isPanelReady) {
      anchorRef.current?.scrollIntoView(
        APPLICANT_DECISION_ANCHOR_SCROLL_OPTIONS
      )

      searchParams.delete(APPLICANT_PROFILE_BLOCK_PARAM)

      setSearchParams(searchParams, { replace: true })
    }
  }, [isPanelReady, isRequested])

  return anchorRef
}
